var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _rect3, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 68,
    height: 68,
    rx: 18,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 42H46V60H17V42Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 39C19.2 38.7 24.2 35.4 26.5 29H54.5C56.8 35.4 61.8 38.7 66 39V44H15V39Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29H57V34H24V29Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 35H32L29.5 44H25.5L28 35Z",
    fill: "#F06A2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35H42L41 44H37L38 35Z",
    fill: "#F06A2F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35H53L56 44H52L49 35Z",
    fill: "#F06A2F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 48,
    width: 7,
    height: 7,
    rx: 1,
    fill: "#F06A2F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 48,
    width: 7,
    height: 7,
    rx: 1,
    fill: "#F06A2F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47 60V49C47 46.7909 48.7909 45 51 45H54C56.2091 45 58 46.7909 58 49V60H47Z",
    fill: "#F06A2F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57 55C59.5 50 65 47 70 48.5C64.7 42.4 57.6 40.1 51.5 43.2L51.5 35L34.5 50L51.5 65L51.5 57.5C56.1 57.1 61.6 59.6 64 67C64.4 62.2 62.2 57.6 57 55Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 14,
    y1: 11,
    x2: 67,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7A35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05D25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkTransfer);
export default __webpack_public_path__ + "static/media/bookmark_transfer.f51370d1aeda59de1c9fbe64905c17cc.svg";
export { ForwardRef as ReactComponent };